module.exports = __webpack_public_path__ + "videos/filters_en.c084f2f.mp4";